import React, { Component } from "react";
import styled from "styled-components";

const Ul = styled.ul`
  padding-left: 0;
  @media screen and (max-width: 900px) {
    margin-top: 0px;
  }
`;

export default class NavList extends Component {
  render() {
    const { children } = this.props;
    return <Ul {...this.props}>{children}</Ul>;
  }
}



// WEBPACK FOOTER //
// ./src/components/Navigation/NavList.js